import React from 'react';

const IconUserBlack = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="40"
      fill="none"
      viewBox="0 0 44 40"
    >
      <rect width="44" height="40" fill="#19191A" rx="12"></rect>
      <circle cx="22" cy="20" r="11.5" stroke="#F8F8F8"></circle>
      <path
        stroke="#F8F8F8"
        d="M22 22.415c4.123 0 7.356 2.812 7.493 6.188-3.366 2.905-7.113 3.155-10.06 2.533-1.501-.317-2.785-.859-3.684-1.382a6 6 0 0 1-1.016-.716 1.5 1.5 0 0 1-.22-.242l-.012-.02c.032-3.453 3.306-6.361 7.499-6.361Z"
      ></path>
      <circle cx="22" cy="20" r="11.5" stroke="#F8F8F8"></circle>
      <circle cx="22" cy="17" r="4.5" stroke="#F8F8F8"></circle>
      <path fill="#19191A" d="M9 18.5h3v4H9z"></path>
      <path
        stroke="#F8F8F8"
        strokeLinecap="round"
        d="M7 20.5h8.5m0 0-2.5 2m2.5-2-2.5-2"
      ></path>
    </svg>
  );
};

export default IconUserBlack;
